/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const UNLIST_ASSET = gql`
mutation Mutation($input: UnListAssetInput) {
    unlistFromStore(input: $input) {
      token_id
      status
    }
  }
`;

